import React, { useState } from "react";
import { BreakdownOptions } from "./ProductDetailPageResult";
import VariationTile from "./components/VariationTile";
import { getDivideByQuantityPricePerPackagingItem } from "./components/VariationTile/shared/utils";
import getLowestPrice from "./Pricing/getLowestPrice";
import { User, withUserAndChat } from "~/common/Store/connectUserAndChat";
interface Props {
  itemNumber: string;
  breakdownOptions: BreakdownOptions[];
  user: User;
}
const ProductBreakdowns = ({
  itemNumber,
  breakdownOptions,
  user
}: Props) => {
  const [activeItemNumber, setActiveItemNumber] = useState(itemNumber);
  const lowerCaseItemNumber = itemNumber.toLowerCase();
  const getUpdatedVariationText = (quantityPerPackaging: number, unitOfMeasure: string) => {
    if (quantityPerPackaging > 1) {
      return `${quantityPerPackaging.toLocaleString()}/${unitOfMeasure}`;
    }
    return unitOfMeasure;
  };
  const variationHeading = (breakdownGroup: BreakdownOptions[]) => {
    const currentSelectedItem = breakdownGroup.find(item => item.itemNumber === activeItemNumber);
    const updatedVariationText = getUpdatedVariationText(currentSelectedItem?.quantityPerPackaging ?? 0, currentSelectedItem?.unitOfMeasurement ?? "");
    return <h2 id="available-quantities" className="mb-1 text-sm" data-sentry-component="variationHeading" data-sentry-source-file="ProductBreakdowns.tsx">
        Quantity:
        <span className="font-normal"> {updatedVariationText}</span>
      </h2>;
  };
  const hideDivideByQuantityPriceForMoreThenOneSample = breakdownOptions.some(item => item.quantityPerPackaging > 1 && item.unitOfMeasurement?.toLowerCase() === "sample");
  const hideDivideByQuantityPriceForSameUoms = breakdownOptions.every(unit => unit.unitOfMeasurement?.toLowerCase() === breakdownOptions[0]?.unitOfMeasurement?.toLowerCase());
  const hideDivideByQuantityPrice = hideDivideByQuantityPriceForSameUoms || hideDivideByQuantityPriceForMoreThenOneSample;
  return <>
      {breakdownOptions?.length > 1 && <div>
          {variationHeading(breakdownOptions)}
          <ul aria-labelledby="available-quantities" data-testid="available-quantities" className="grid grid-flow-row grid-cols-3 lt:grid-cols-2 [@media(min-width:1150px)]:grid-cols-3 auto-rows-fr gap-2 list-none m-0">
            {breakdownOptions.map(({
          price,
          link,
          quantityPerPackaging,
          unitOfMeasurement,
          isWebstaurantPlusEligible,
          itemNumber: breakdownItemNumber,
          showBelowMinimumAdvertisedPriceForLoggedInCustomers,
          showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers
        }) => {
          const lowestPrice = price && getLowestPrice(price, showBelowMinimumAdvertisedPriceForLoggedInCustomers, showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers, user, false);
          const divideByPackagingData = getDivideByQuantityPricePerPackagingItem(breakdownOptions, breakdownItemNumber, user);
          return <li key={`li-${quantityPerPackaging}`} data-testid={breakdownItemNumber}>
                    <VariationTile.Quantity key={breakdownItemNumber} link={`${lowerCaseItemNumber === breakdownItemNumber ? "#" : link}`} price={lowestPrice} itemNumber={breakdownItemNumber} currentSelectedItemNumber={lowerCaseItemNumber} pricePerUom={hideDivideByQuantityPrice ? 0 : divideByPackagingData?.[0]?.divideByLowestQuantity ?? 0} variationText={getUpdatedVariationText(quantityPerPackaging, unitOfMeasurement)} unitOfMeasure={hideDivideByQuantityPrice ? "" : divideByPackagingData?.[0]?.minUnit ?? ""} isPlusEligible={isWebstaurantPlusEligible} setActiveItemNumber={setActiveItemNumber} />
                  </li>;
        })}
          </ul>
        </div>}
    </>;
};
export default withUserAndChat(ProductBreakdowns);